<header class="p-3 sticky-top glass-header">
  <div class="container-fluid px-lg-5">
    <div class="d-flex align-items-center justify-content-between flex-wrap flex-lg-nowrap gap-2 gap-lg-3 mx-lg-4">
      <!-- Left: Logo & Brand -->
      <div class="d-flex align-items-center shrink-0">
        <a role="button" [routerLink]="['/']" class="text-decoration-none d-flex align-items-center">
          <div *ngIf="isLogoLoading" class="logo-skeleton"></div>
          <img *ngIf="!isLogoLoading" src="{{ logo }}" onError="this.src='assets/images/logo_default.png'"
            class="me-2 logo" alt="Logo" />
          <span id="brand-text"
            class="h6 fw-bold text-dark my-auto brand-text text-truncate d-none d-sm-inline-block">{{ brandheading
            }}</span>
        </a>
      </div>

      <!-- Center: Search Area -->
      <div class="grow order-3 order-lg-2 w-100 px-lg-3">
        <div class="input-group search-group shadow-sm mx-auto" style="max-width: 650px;">
          <!-- location selection inside search -->
          <button type="button" class="btn btn-browse-in-search border-end px-3 shadow-none"
            *ngIf="locationList?.length > 1" [ngClass]="{'dropdown-toggle': locationList?.length > 1}"
            [attr.data-bs-toggle]="locationList?.length > 1 ? 'dropdown' : null" aria-expanded="false">
            <i class="bi bi-geo-alt-fill me-1"></i>
            <span class="d-none d-md-inline">{{ locationNameMain | translate | shortTitle: 15 }}</span>
          </button>
          <ul class="dropdown-menu shadow-lg border-0" *ngIf="locationList?.length > 1"
            style="max-height: calc(100vh - 120px); overflow-y: auto;">
            <li>
              <a class="dropdown-item py-2" role="button" (click)="ChangeLocation('', 'All location')">
                <i class="bi bi-geo-alt me-2"></i> {{ "All location" | translate }}
              </a>
            </li>
            <li *ngFor="let l of locationList">
              <a class="dropdown-item py-2" role="button" [ngClass]="{'active': l.active}"
                (click)="ChangeLocation(l.LOCATIONID, l.LOCATIONNAME)">
                <i class="bi bi-geo-alt me-2"></i> {{ l.LOCATIONNAME }}
              </a>
            </li>
          </ul>

          <form class="grow" [formGroup]="qsearchForm">
            <input type="search" class="form-control border-0 bg-transparent py-2 px-3 shadow-none"
              placeholder="{{ 'Search' | translate }}..." formControlName="textSearch" id="TextSearch"
              (keydown.enter)="search()" aria-label="Search" />
          </form>
          <button class="btn btn-search-icon " type="button" (click)="search()">
            <i class="bi bi-search"></i>
          </button>
        </div>
      </div>



      <!-- Right: Actions -->
      <div class="d-flex align-items-center gap-2 gap-xl-3 order-2 order-lg-3 ms-auto ms-lg-0">

        <!-- Desktop Actions Group -->
        <div class="d-none d-lg-flex align-items-center gap-2 gap-xl-3">
          <!-- Browse Button -->
          <button class="btn btn-lang-switcher dropdown-toggle border-0 shadow-none px-2" type="button"
            data-bs-toggle="modal" data-bs-target="#browseModal">
            <i class="bi bi-grid-fill"></i>
            <span class="fw-bold ms-2 d-none d-xxl-inline text-nowrap">{{ 'Browse' | translate }}</span>
          </button>
          <!-- Language Dropdown -->
          <div class="dropdown">
            <button type="button" class="btn btn-lang-switcher dropdown-toggle border-0 shadow-none px-2"
              data-bs-toggle="dropdown">
              <img *ngIf="CurrentLang == 'en'; else lang_th_desktop" width="22px" class="rounded-1"
                src="assets/images/lang/United-kingdom_29738.png" alt="English" />
              <ng-template #lang_th_desktop>
                <img width="22px" class="rounded-1" src="assets/images/lang/th_icon_127999.png" alt="Thai" />
              </ng-template>
              <span class="lang-code ms-1">{{ CurrentLang }}</span>
            </button>
            <ul class="dropdown-menu shadow-xl border-0 p-2 mt-2">
              <li>
                <button class="dropdown-item dropdown-item-lang py-2" (click)="changeLanguage('th')">
                  <img src="assets/images/lang/th_icon_127999.png" width="18px" alt="TH">
                  <span>ภาษาไทย</span>
                </button>
              </li>
              <li>
                <button class="dropdown-item dropdown-item-lang py-2" (click)="changeLanguage('en')">
                  <img src="assets/images/lang/United-kingdom_29738.png" width="18px" alt="EN">
                  <span>English</span>
                </button>
              </li>
            </ul>
          </div>

          <!-- Export Button -->
          <button type="button" (click)="export()"
            class="btn btn-export-modern border-0 position-relative shadow-none px-2 d-flex align-items-center">
            <i class="bi bi-file-earmark-arrow-down fs-5"></i>
            <span class="ms-1 d-none d-xxl-inline text-nowrap">{{ 'Export' | translate }}</span>
            <span
              class="badge rounded-pill bg-danger border border-white position-absolute top-0 start-100 translate-middle"
              style="font-size: 0.65rem; padding: 0.35em 0.5em;" *ngIf="listBib.length > 0">{{ listBib.length }}</span>
          </button>


        </div>

        <!-- User/Login Area -->
        <div class="d-flex align-items-center">
          <!-- Non-logged in state (Desktop Only) -->
          <button class="btn btn-login-modern px-3 py-2 d-none d-lg-flex shadow-sm" [routerLink]="['/login']"
            *ngIf="currentUser.length == 0">
            <i class="bi bi-person-fill me-1"></i> {{'login' | translate}}
          </button>

          <!-- Logged in state -->
          <div class="dropdown" *ngIf="currentUser.length > 0">
            <button type="button" class="btn btn-user-profile dropdown-toggle border-0 shadow-none p-1 pe-3"
              data-bs-toggle="dropdown">
              <div class="user-avatar-wrap">
                <img [src]="MemberImg" onError="this.src='assets/images/member-icon.jpg'" class="user-avatar"
                  alt="Avatar" />
              </div>
              <div class="user-meta-text d-none d-lg-flex">
                <span class="user-greeting">{{ 'welcome' | translate }}</span>
                <span class="user-name-label text-truncate">{{ currentUser[0].FNAMETHAI }}</span>
              </div>
            </button>
            <ul class="dropdown-menu dropdown-menu-end shadow border-0 p-3 mt-1" style="min-width: 250px;">
              <li class="dropdown-user-header">
                <span class="user-display-name text-truncate fw-bold text-primary">{{ currentUser[0].FNAMETHAI + ' ' +
                  currentUser[0].LNAMETHAI }}</span>
                <span class="mt-1">
                  <i class="bi bi-shield-check me-1"></i>
                  {{ (isAdmin == '1' ? 'Admin' : 'Member') | translate }}
                </span>
              </li>
              <li><hr class="dropdown-divider mx-2" /></li>
              <li><a class="dropdown-item py-2" [routerLink]="['/member']">
                  <i class="bi bi-person-circle me-2"></i> {{'Profile' | translate}}</a>
              </li>
              <li><a class="dropdown-item py-2" [routerLink]="['/admin']" *ngIf="isAdmin == '1'">
                  <i class="bi bi-gear-fill me-2"></i> {{'AdminSettings' | translate}}</a>
              </li>
              <li>
                <hr class="dropdown-divider mx-2" />
              </li>
              <li><button class="dropdown-item py-2 text-danger" (click)="SiginOut()">
                  <i class="bi bi-box-arrow-right me-2"></i> {{'Logout' | translate}}</button>
              </li>
            </ul>
          </div>
        </div>

        <!-- Hamburger (Hidden on Desktop) -->
        <button class="btn btn-header-action d-lg-none border-0 shadow-none p-0" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarMobileCollapse">
          <i class="bi bi-list fs-1 text-dark"></i>
        </button>
      </div>

      <!-- Mobile Collapse Area -->
      <div class="collapse navbar-collapse col-12 order-5 d-lg-none" id="navbarMobileCollapse">
        <div class="bg-light rounded-4 p-3 mt-2 mb-3 shadow-sm border">
          <div class="d-flex flex-column gap-3">
            <button class="btn btn-location w-100 text-start py-2" type="button" data-bs-toggle="modal"
              data-bs-target="#browseModal">
              <i class="bi bi-grid-fill me-2"></i> {{ 'Browse' | translate }}
            </button>

            <div class="d-flex align-items-center justify-content-between px-2">
              <span class="text-secondary small fw-bold">{{ 'Language' | translate }}</span>
              <div class="btn-group btn-group-sm">
                <button class="btn btn-outline-primary py-1" [class.active]="CurrentLang == 'th'"
                  (click)="changeLanguage('th')">TH</button>
                <button class="btn btn-outline-primary py-1" [class.active]="CurrentLang == 'en'"
                  (click)="changeLanguage('en')">EN</button>
              </div>
            </div>

            <button class="btn btn-outline-primary w-100 text-start py-2" (click)="export()">
              <i class="bi bi-file-earmark-arrow-down me-2"></i> {{ 'Export' | translate }}
              <span class="badge rounded-pill bg-danger float-end mt-1">{{ listBib.length }}</span>
            </button>

            <!-- Login Button in Hamburger -->
            <button class="btn btn-login-modern w-100 justify-content-center py-2" [routerLink]="['/login']"
              *ngIf="currentUser.length == 0">
              <i class="bi bi-person-fill me-2"></i> {{'login' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- Modal -->
<div class="modal fade" id="browseModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{'Browse' | translate}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="accordion" id="accordionExample">
          <!-- LC & NLM call number -->
          @if(callNoLC?.length > 0){
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                {{ "LC & NLM call number" | translate }}
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
              data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" *ngFor="let lc of callNoLC">
                    <a class="wl-font-color-gray-v1" href="results?Ntk=CALLNUMBERLC&Ntt={{ lc.value }}*">{{ lc.display
                      }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          }

          <!-- DC call number -->

          @if(callNoDC?.length > 0){
          <div class="accordion-item">
            <h2 class="accordion-header" id="heading4">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#accordioncallNoDC" aria-expanded="false" aria-controls="accordioncallNoDC">
                {{ "DC call number" | translate }}
              </button>
            </h2>
            <div id="accordioncallNoDC" class="accordion-collapse collapse" aria-labelledby="heading4"
              data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" *ngFor="let lc of callNoDC">
                    <a class="wl-font-color-gray-v1" href="results?Ntk=CALLNUMBERDC&Ntt={{ lc.value }}*">{{ lc.display
                      }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          }

          <!-- Local call number -->
          @if(callNoLocal?.length > 0){
          <div class="accordion-item">
            <h2 class="accordion-header" id="heading5">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#accordionCALLNUMBERLOCAL" aria-expanded="false"
                aria-controls="accordionCALLNUMBERLOCAL">
                {{ "Local call number" | translate }}
              </button>
            </h2>
            <div id="accordionCALLNUMBERLOCAL" class="accordion-collapse collapse" aria-labelledby="heading5"
              data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" *ngFor="let lc of callNoLocal">
                    <a class="wl-font-color-gray-v1" href="results?Ntk=CALLNUMBERLOCAL&Ntt={{ lc.value }}*">{{
                      lc.display }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          }

          <!-- SourceType -->
          @if(materialTypes?.length > 0){
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseSourceType" aria-expanded="true" aria-controls="collapseSourceType">
                {{ "SourceType" | translate }}
              </button>
            </h2>
            <div id="collapseSourceType" class="accordion-collapse collapse show" aria-labelledby="headingOne"
              data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" *ngFor="let type of materialTypes">
                    <a class="wl-font-color-gray-v1" href="results?Ntk=MEDIATYPE&Ntt={{ type.MATTYPEID }}">{{
                      type.MATTYPENAME }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          }

          <!-- Collection -->
          @if(locationCollectionResponse?.length > 0){
          <div class="accordion-item">
            <h2 class="accordion-header" id="heading6">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseCollection" aria-expanded="false" aria-controls="collapseCollection">
                {{ "Collection" | translate }}
              </button>
            </h2>
            <div id="collapseCollection" class="accordion-collapse collapse" aria-labelledby="heading6"
              data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="mt-4" *ngFor="let lo of locationCollectionResponse">
                  <p class="h5">{{ lo.LOCATIONNAMETHAI }}</p>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" *ngFor="let col of lo.collections">
                      <a class="wl-font-color-gray-v1" href="results?Ntk=LOCATION|COLLECTION&Ntt={{
                          lo.locationid
                        }}|{{ col.Value }}">{{ col.DISPLAY }}</a>
                      <!-- nPage=1&Ntk=LOCATION|COLLECTION&Ntt=1|76 -->
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          }

          <!-- Language -->
          @if(langs?.length > 0){
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseLanguage" aria-expanded="false" aria-controls="collapseLanguage">
                {{ "Language" | translate }}
              </button>
            </h2>
            <div id="collapseLanguage" class="accordion-collapse collapse" aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <ng-container *ngIf="moreLang === false; then show10Lang; else showAllLang"></ng-container>
                <ng-template #show10Lang>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" *ngFor="let lang of langs | slice : 0 : 10; let i = index">
                      <a class="wl-font-color-gray-v1" href="results?Ntk=LANG&Ntt={{ lang.LANGCODE }}">{{ lang.Display
                        }}</a>
                    </li>
                    <li class="list-group-item">
                      <a class="wl-font-color-default" (click)="showMore()">{{ 'More' | translate }}..</a>
                    </li>
                  </ul>
                </ng-template>
                <ng-template #showAllLang>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" *ngFor="let lang of langs">
                      <a class="wl-font-color-gray-v1" href="results?Ntk=LANG&Ntt={{ lang.LANGCODE }}">{{ lang.Display
                        }}</a>
                    </li>
                    <li class="list-group-item">
                      <a class="wl-font-color-default" (click)="showLess()">..{{ 'Less' | translate }}</a>
                    </li>
                  </ul>
                </ng-template>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{ 'Close' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>